import React from 'react';
import './TableToolbar.scss';

/**
 * TableCard — a consistent card shell for list pages. Wrap the toolbar + the
 * DataTable so both live inside one bordered, rounded card (matches the
 * Leave Request layout used app-wide).
 */
function TableCard({ children, className = '' }) {
  return <div className={`app-table-card ${className}`.trim()}>{children}</div>;
}

export default TableCard;
